// Frontend logging helper for the API logger service
import { apiConfig } from '../config/apiConfig';
import { createSessionHeaders } from '../utils/sessionManager';

const isLoggerConfigured = (url) =>
  Boolean(url) && !url.includes('YOUR-PROD-API-ID');

const stripEmptyFields = (payload) =>
  Object.entries(payload).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      acc[key] = value;
    }
    return acc;
  }, {});

export const logFrontendEvent = async ({
  endpoint,
  method = 'GET',
  requestParams,
  requestBody,
  bbox,
  imageDate,
  locationName,
  cloudCoverage,
  processingStage,
  responseStatusCode,
  responseSizeBytes,
  errorMessage,
} = {}) => {
  const loggerUrl = apiConfig?.apiLogger;
  if (!isLoggerConfigured(loggerUrl) || !endpoint) {
    return;
  }

  const sessionHeaders = createSessionHeaders();
  const payload = stripEmptyFields({
    service_name: 'sentimezoom-frontend',
    endpoint,
    method,
    request_timestamp: new Date().toISOString(),
    user_id: sessionHeaders['X-STM-User-ID'],
    session_id: sessionHeaders['X-STM-Session-ID'],
    user_email: sessionHeaders['X-STM-User-Email'],
    user_agent: navigator.userAgent,
    request_params: requestParams,
    request_body: requestBody,
    request_headers: sessionHeaders,
    bbox,
    location_name: locationName,
    image_date: imageDate,
    cloud_coverage: cloudCoverage,
    processing_stage: processingStage,
    response_status_code: responseStatusCode,
    response_size_bytes: responseSizeBytes,
    error_message: errorMessage,
  });

  try {
    await fetch(loggerUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...sessionHeaders,
      },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch (error) {
    console.warn('Frontend logger request failed:', error);
  }
};
